/**
 * The language Google Maps answers in: the one chosen in the app, not the
 * phone's.
 *
 * WHY. The Maps script was loaded with no `language`, so Google used the
 * phone's. Sofia's Android is set to Spanish while the app was in English then
 * in French: places read « Annecy, Haute-Savoie, Francia », the map said
 * « Ginebra » and « Datos del mapa » (recette du 28/10/2026, B9).
 *
 * The script loads in main.ts, before Angular and before the Ionic storage
 * that keeps the chosen language is open, and Maps cannot change language once
 * loaded. So the language service also writes the choice where main.ts can
 * read it at once, and a change shows on the map the next time the app starts.
 */
export const MAP_LANGUAGE_KEY = 'smatchy.mapLanguage';

const SPOKEN = ['fr', 'en'];

/**
 * The stored choice when there is one, else the rule the language service
 * applies to a first start: English for an English phone, French otherwise.
 */
export function theMapLanguage(stored: string | null | undefined, phoneLanguage: string | undefined): string {
  if (stored && SPOKEN.includes(stored)) {
    return stored;
  }
  return (phoneLanguage ?? '').split('-')[0] === 'en' ? 'en' : 'fr';
}

/** Never throws: a phone that refuses local storage keeps the rule above. */
export function readTheMapLanguage(): string {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(MAP_LANGUAGE_KEY);
  } catch {
    stored = null;
  }
  return theMapLanguage(stored, typeof navigator === 'undefined' ? undefined : navigator.language);
}

export function rememberTheMapLanguage(lang: string): void {
  try {
    localStorage.setItem(MAP_LANGUAGE_KEY, lang);
  } catch {
    // The map then follows the first-start rule, as before this file.
  }
}
